import { render, staticRenderFns } from "./edutalk-attendance.vue?vue&type=template&id=34d5697c"
import script from "./edutalk-attendance.vue?vue&type=script&lang=js"
export * from "./edutalk-attendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports